import { color, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Breakpoints from "../../Breakpoints";
export const StatusBox = styled(Breakpoints.Box) `
  border-radius: ${size.borderRadius};
  background-color: ${color.background.selectableBox.default};
  position: relative;

  // hack to prevent safari border glitch
  border-color: transparent;
  border-left-width: ${spacing.base.s};
  border-left-style: solid;

  &:before {
    content: "";
    background-color: ${color.status.info.default};
    height: 100%;
    width: ${spacing.base.s};
    position: absolute;
    left: -${spacing.base.s};
    top: 0;
    border-top-left-radius: ${size.borderRadius};
    border-bottom-left-radius: ${size.borderRadius};
  }

  &.warning {
    &:before {
      background-color: ${color.status.warning.default};
    }
  }

  &.error {
    &:before {
      background-color: ${color.status.error.default};
    }
  }

  &.success {
    &:before {
      background-color: ${color.status.success.default};
    }
  }

  &.condensed {
    border-left-width: ${spacing.base.xs};

    &:before {
      width: ${spacing.base.xs};
      left: -${spacing.base.xs};
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RhdHVzQm94LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU3RhdHVzQm94L3N0eWxlZC9TdGF0dXNCb3gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLEtBQUssRUFDTCxJQUFJLEVBQ0osT0FBTyxHQUNSLE1BQU0sZ0RBQWdELENBQUM7QUFDeEQsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxXQUFXLE1BQU0sbUJBQW1CLENBQUM7QUFFNUMsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxXQUFXLENBQUMsR0FBRyxDQUFDLENBQUE7bUJBQzdCLElBQUksQ0FBQyxZQUFZO3NCQUNkLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLE9BQU87Ozs7O3VCQUtyQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7Ozs7O3dCQUtiLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU87O2FBRXBDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQzs7YUFFZCxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7OzhCQUVHLElBQUksQ0FBQyxZQUFZO2lDQUNkLElBQUksQ0FBQyxZQUFZOzs7OzswQkFLeEIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTzs7Ozs7OzBCQU01QixLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxPQUFPOzs7Ozs7MEJBTTFCLEtBQUssQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLE9BQU87Ozs7O3lCQUs3QixPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7OztlQUd6QixPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7ZUFDZixPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7OztDQUc3QixDQUFDIn0=